import React, { FC, useRef, useMemo, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { StepperRefProps } from 'src/front/components/StepperView';
import Application from 'src/front/components/Application';
import LoanApplicationProvider from 'src/front/contexts/LoanApplicationContext';
import ProductInformation from './product-information/ProductInformation';
import CustomerSearch from './customer-information/CustomerSearch';
import IndividualInformation from './customer-information/IndividualInformation';

import DocumentEntry from './customer-information/document-entry/DocumentEntry';

import PhoneEmailEntry from './phone-email-entry/PhoneEmailEntry';
import AddressEntry from './address-entry/AddressEntry';
import TaxInformation from './tax-information/TaxInformation';

const LoanApplication: FC = () => {
  const { t } = useTranslation();
  const stepperRef = useRef<StepperRefProps>(null);

  const goToNextStep = async (id?: string): Promise<void> => {
    stepperRef.current?.goToNextStep();
  };
  const steps = [
    {
      component: () => <ProductInformation goToNextStep={goToNextStep} />,
    },
    {
      component: () => <CustomerSearch goToNextStep={goToNextStep} />,
    },
    {
      component: () => <IndividualInformation goToNextStep={goToNextStep} />,
    },
    { component: () => <DocumentEntry goToNextStep={goToNextStep} /> },
    { component: () => <AddressEntry goToNextStep={goToNextStep} /> },
    { component: () => <PhoneEmailEntry goToNextStep={goToNextStep} /> },
    { component: () => <TaxInformation goToNextStep={goToNextStep} /> },
  ];
  const stepsVertical = useMemo(() => {
    const stepDefinitions = [
      {
        text: t('cardEntry_stepper_productStep_title'),
      },
      {
        text: t('cardEntry_stepper_customerStep_title'),
        subSteps: [
          {
            text: t('cardEntry_stepper_customerStepSub1_title'),
          },
          {
            text: t('cardEntry_stepper_customerStepSub2_title'),
          },
          {
            text: t('cardEntry_stepper_customerStepSub3_title'),
          },
        ],
      },
      {
        text: t('cardEntry_stepper_contactStep_title'),
        subSteps: [
          {
            text: t('cardEntry_stepper_contactStepSub1_title'),
          },
          {
            text: t('cardEntry_stepper_contactStepSub2_title'),
          },
        ],
      },
      {
        text: t('cardEntry_taxInfo_taxInfo_title'),
      },
    ];
    return stepDefinitions.map((item, index) => ({
      text: item.text,
      index: index + 1,
      ...(item?.subSteps
        ? {
            subSteps: item.subSteps?.map((subItem, subIndex) => ({
              text: subItem.text,
              index: subIndex + 1,
            })),
          }
        : {}),
    }));
  }, [t]);

  return <Application stepperRef={stepperRef} steps={steps} stepsVertical={stepsVertical} />;
};
export default (): ReactElement => (
  <LoanApplicationProvider>
    <LoanApplication />
  </LoanApplicationProvider>
);
